export const LOCALES = ['en', 'fr', 'de', 'it'] as const
export type Locale = (typeof LOCALES)[number]

/**
 * Catalogue keys, plus the hyphenated aliases the public app already requests
 * (`land-analysis`, `building-analysis`) and the UI library namespaces.
 */
export const NAMESPACES = [
  'amenities',
  'buildingAnalysis',
  'buildings',
  'charts',
  'common',
  'comparables',
  'demographics',
  'electricity',
  'elevation',
  'employment',
  'energy',
  'environment',
  'estimate',
  'explore',
  'feasibility',
  'geoAnalysis',
  'history',
  'landAnalysis',
  'listings',
  'market',
  'noise',
  'property',
  'restrictions',
  'sunlight',
  'taxes',
  'transactions',
  'transport',
  'valuations',
  'zoning',
  'land-analysis',
  'building-analysis',
  'ui',
  'gwr',
  'characteristics',
] as const

export type Namespace = (typeof NAMESPACES)[number]
